import * as React from 'react'
import { useAuth } from 'src/hooks/auth/authObservableValue'
import { useTranslatable } from 'src/hooks/locale/utils'
import { useUserState } from 'src/hooks/userState'
import SuspenseWrapper from 'src/views/includes/SuspenseWrapper'

export default function ProfilePersonalInformationPage(): JSX.Element | null {
  const t = useTranslatable()

  return (
    <SuspenseWrapper title={t('person:personal_information_profile')}>
      <PageContent />
    </SuspenseWrapper>
  )
}

function PageContent(): React.ReactElement | null {
  const t = useTranslatable()
  const auth = useAuth()
  const userState = useUserState()

  if (auth.state !== 'Authenticated') return null

  const fields = [
    ...(auth.profile.type === 'UserProfileStudent'
      ? [{ label: t('person:billing_id'), value: userState.data?.billingId ?? '-' }]
      : []),
    {
      label: t('person:degree'),
      value: t(`degrees:${auth.profile.degree}`),
    },
    {
      label: t('person:firstname'),
      value: auth.user.firstName,
    },
    {
      label: t('person:lastname'),
      value: auth.user.lastName,
    },
    {
      label: t('person:personal_number'),
      value: auth.user.personalNumber,
    },
    {
      label: t('person:birth_date'),
      value: auth.user.birthDate,
    },
    {
      label: t('person:juridical_address'),
      value: auth.user.juridicalAddress,
    },
  ]

  return (
    <div
      className="mt-6 w-full rounded-xl bg-card py-9 pl-9 text-primaryTextColor sm:px-9"
      data-testid="personalInformation"
    >
      {fields.map((field, key) => (
        <div key={key} className="mb-2.5 grid grid-cols-6">
          <div className="col-span-2">
            <label className="font-bold">{field.label}:</label>
          </div>
          <div className="col-span-4 float-left">
            <div>{field.value}</div>
          </div>
        </div>
      ))}
    </div>
  )
}
